import React, { useEffect, useRef, useState } from 'react';
import useAuth from 'context/useAuth';

import { AppRoutes } from 'routes';

import IdleTimer from './IdleTimer';
import SessionWarningModal from './SessionWarningModal';

const IdleTimerContainer = () => {
    const [displayModal, updateModalVisibility] = useState(false);
    const [timeoutCountdown, setTimeoutCountdown] = useState(0);
    const sessionTimeoutRef = useRef(null);
    const timeOutRef = useRef(null);
    const { signOut, user } = useAuth();
    const _timeout = 4 * 60;

    useEffect(() => {
        if (!user) {
            return;
        }
        timer.start();
        return () => {
            timer.cleanUp();
        };
    }, [user]);

    const timer = new IdleTimer({
        onIdle: () => {
            onIdle();
        },
        timeout: _timeout,
    });

    const startInterval = (countDown) => {
        timeOutRef.current = setInterval(() => {
            if (countDown > 0) {
                setTimeoutCountdown(--countDown);
            }
        }, 1000);
    };
    /**
     * It is triggered after the 4 minutes of idle time. It starts the 60 seconds countdown and then logs the user out if there is no activity.
     */
    const onIdle = () => {
        setTimeout(() => {
            let countDown = 60;
            updateModalVisibility(true);
            sessionTimeoutRef.current = setTimeout(logOut, 60000);
            setTimeoutCountdown(countDown);
            startInterval(countDown);
        }, 1000);
    };

    /**
     * It allows the user to stay signed in and resets the timeout timer.
     */
    const stayActive = () => {
        updateModalVisibility(false);
        clearTimeout(sessionTimeoutRef.current);
        clearInterval(timeOutRef.current);
        timer.start();
    };

    const logOut = () => {
        clearTimeout(sessionTimeoutRef.current);
        clearInterval(timeOutRef.current);
        signOut(AppRoutes.sessionExpiredPage);
    };
    return <SessionWarningModal countDown={timeoutCountdown} onOk={stayActive} visible={displayModal} />;
};

export default IdleTimerContainer;
